import { Injectable } from '@angular/core';
import { BaseErrorHandlerModel, ExtendedServerErrorResponse, LoggingService } from '@app-core';

@Injectable({
    providedIn: 'root',
})
export class ServerErrorHandlerService extends BaseErrorHandlerModel {
    override handle(error: ExtendedServerErrorResponse): void {
        LoggingService.log('ServerErrorHandlerService::handle:', error);
        this.router.navigate(['/error']);
    }
}
